(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery-availability"] && !Shopify.designMode) return;
  try {
    
class DeliveryAvailability extends HTMLElement {
  connectedCallback() {
    this._loading = false;
    this._address = '';
    this._apiUrl = this.dataset.apiUrl || '';

    this._inputs = Array.from(this.querySelectorAll('.da__input'));
    this._submitBtns = Array.from(this.querySelectorAll('[data-action="submit"]'));
    this._resetBtns = Array.from(this.querySelectorAll('[data-action="reset"]'));

    this._prefix = this._slotText('address-prefix');
    this._unit = this._slotText('distance-unit');
    this._errRate = this._slotText('error-ratelimit');
    this._errGeneric = this._slotText('error-generic');

    this._inputs.forEach((input) => {
      input.addEventListener('input', () => {
        this._address = input.value;
        this._inputs.forEach((other) => {
          if (other !== input) other.value = this._address;
        });
        this._hideValidation();
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this._handleSubmit();
        }
      });
    });

    this._submitBtns.forEach((btn) => btn.addEventListener('click', () => this._handleSubmit()));
    this._resetBtns.forEach((btn) => btn.addEventListener('click', () => this._reset()));
  }

  _slotText(name) {
    const el = this.querySelector('[data-slot="' + name + '"]');
    return el ? el.textContent.trim() : '';
  }

  _visibleCard() {
    return this.querySelector('[data-state]:not([hidden])');
  }

  _handleSubmit() {
    if (this._loading) return;
    const addr = (this._address || '').trim();
    if (!addr) {
      this._showValidation();
      return;
    }
    this._hideValidation();
    this._check(addr);
  }

  async _check(addr) {
    this._setLoading(true);
    try {
      const res = await fetch(
        this._apiUrl + '/geolocation/availability?search=' + encodeURIComponent(addr),
        { headers: { Accept: 'application/json' } },
      );
      let body = null;
      try {
        body = await res.json();
      } catch (_e) {
        body = null;
      }
      const state = this._mapResponse(res.status, body);
      this._renderState(state, addr, body);
    } catch (_err) {
      this._renderState('error-generic', addr, null);
    } finally {
      this._setLoading(false);
    }
  }

  _mapResponse(status, body) {
    if (status === 429) return 'error-ratelimit';
    if (status < 200 || status >= 300) return 'error-generic';
    if (!body) return 'error-generic';
    if (body.availability === true) return 'available';
    if (body.availability === false && body.distance === null) return 'unrecognized';
    return 'unavailable';
  }

  _renderState(state, addr, body) {
    if (state === 'available') {
      this._fillAddress('available', addr, body);
      this._showState('available');
    } else if (state === 'unavailable') {
      this._fillAddress('unavailable', addr, body);
      this._showState('unavailable');
    } else if (state === 'unrecognized') {
      this._showState('unrecognized');
    } else if (state === 'error-ratelimit') {
      this._setErrorMessage(this._errRate);
      this._showState('error');
    } else {
      this._setErrorMessage(this._errGeneric);
      this._showState('error');
    }
  }

  _fillAddress(stateName, addr, body) {
    const el = this.querySelector('[data-state="' + stateName + '"] [data-slot="address-line"]');
    if (!el) return;
    let distance = body && body.distance != null ? body.distance : '';
    if (distance !== '') {
      distance = Number(distance).toFixed(2).replace('.', ',');
    }
    const distancePart = distance !== '' ? ' (' + distance + ' ' + this._unit + ')' : '';
    const resolved = body && body.address ? body.address : addr;
    el.textContent = this._prefix + ' ' + resolved + distancePart;
  }

  _setErrorMessage(msg) {
    const el = this.querySelector('[data-state="error"] [data-slot="error-message"]');
    if (el) el.textContent = msg;
  }

  _showState(name) {
    this.querySelectorAll('[data-state]').forEach((el) => {
      el.hidden = el.dataset.state !== name;
    });
    const card = this.querySelector('[data-state="' + name + '"]');
    if (card) {
      const input = card.querySelector('.da__input');
      if (input) input.value = this._address;
    }
    this._hideValidation();
  }

  _reset() {
    this._address = '';
    this._inputs.forEach((input) => {
      input.value = '';
      input.classList.remove('is-invalid');
    });
    this._hideValidation();
    this._showState('form');
  }

  _showValidation() {
    const card = this._visibleCard();
    if (!card) return;
    const msg = card.querySelector('.da__validation');
    const input = card.querySelector('.da__input');
    if (msg) msg.hidden = false;
    if (input) {
      input.classList.add('is-invalid');
      input.focus();
    }
  }

  _hideValidation() {
    this.querySelectorAll('.da__validation').forEach((msg) => {
      msg.hidden = true;
    });
    this.querySelectorAll('.da__input').forEach((input) => {
      input.classList.remove('is-invalid');
    });
  }

  _setLoading(active) {
    this._loading = active;
    this._submitBtns.forEach((btn) => {
      btn.disabled = active;
      btn.classList.toggle('is-loading', active);
    });
  }
}

customElements.define('delivery-availability', DeliveryAvailability);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
